import { PageResult } from '@spike/model';
import { Room } from '@spike/room-model';
import { TableBody } from 'components/UI/V3/Table/Body/TableBody';
import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { TableHeaderCell } from 'components/UI/V3/Table/HeaderCell/TableHeaderCell';
import { Table } from 'components/UI/V3/Table/Table';
import { FunctionComponent } from 'react';
import { useMediaQuery } from 'react-responsive';
import RoomsTableRow from './RoomsTableRow';
import DefaultTableEmptyState from 'components/UI/V3/Table/EmptyState/DefaultTableEmptyState';
import styles from './RoomsTable.module.scss';
import clsx from 'clsx';

interface RoomsTableProps {
    roomsPage: PageResult<Room>;
    isLoading?: boolean;
    className?: string;
    onPageChange?: (page: number) => void;
    onPageSizeChange?: (size: number) => void;
}

export const RoomsTable: FunctionComponent<RoomsTableProps> = props => {
    const isMobile = useMediaQuery({ query: '(max-width:600px)' });

    return (props.roomsPage.pagination?.totalRecords ?? 0) > 0 ? (
        <Table
            pagination={{
                page: props.roomsPage.pagination?.page ?? 1,
                totalPages: props.roomsPage.pagination?.totalPages ?? 1,
                size: props.roomsPage.pagination?.pageSize,
                isLoading: props.isLoading
            }}
            onPageChange={props.onPageChange}
            onSizeChange={props.onPageSizeChange}
            className={props.className}
            fullHeight={true}
        >
            {!isMobile && (
                <TableHeader>
                    <TableHeaderCell>Room Name</TableHeaderCell>
                    <TableHeaderCell>Type</TableHeaderCell>
                    <TableHeaderCell>Quantity</TableHeaderCell>
                    <TableHeaderCell>Staff</TableHeaderCell>
                    <TableHeaderCell>Capacity Rules</TableHeaderCell>
                </TableHeader>
            )}
            <TableBody>
                {props.roomsPage.page.map((room, index) => (
                    <RoomsTableRow
                        key={room.id}
                        room={room}
                        isLast={props.roomsPage.page.length === index + 1}
                    />
                ))}
            </TableBody>
        </Table>
    ) : (
        <Table
            className={clsx(styles.table, props.className)}
            fullHeight={true}
        >
            <TableBody className={styles.tableBody}>
                <DefaultTableEmptyState />
            </TableBody>
        </Table>
    );
};

export default RoomsTable;
